<template>
    <div class="info animated slideInRight">
        <span class="close show" @click="closed"></span>
        <div class="logInfo">
            <span class="tit show fleft">{{$t('lan.creatnew')}}</span>
            <uL class="putlist fleft">
                <li>
                    <input class="inputcls" :class="isname ? 'wrong' : ''" v-model="regname" :placeholder=" username " @focus="focusfns(1)" @blur="blurfns(1)"  />
                </li>
                <li>
                    <input class="inputcls" type="password" :class="ispwdN ? 'wrong' : ''" v-model="newpwd"  :placeholder=" $t('lan.newpwd') " @focus="focusfns(2)" @blur="blurfns(2)"/>
                </li>
                <li>
                    <input class="inputcls" type="password" :class="ispwdO ? 'wrong' : ''" v-model="oldpwd"  :placeholder=" $t('lan.conpwd') " @focus="focusfns(3)" @blur="blurfns(3)"/>
                </li>
                <li>
                    <input class="inputcls" :class="isverName ? 'wrong' : ''" v-model="ver" :placeholder=" verName " @focus="focusfns(4)" @blur="blurfns(4)"/>
                </li>
            </uL>
            <p class="fleft codeYz m2B posn codePut">
                <span class="codeBtn show fleft f24 cur" @click="getCode">{{ istime ? times+'秒后重发' : codeName}}</span>
                <input class="putcode fright" :class="iscode ? 'wrong' : ''" @blur="this.isVer ? checknote() : checkmialVer()" value="" v-model="vercode" :placeholder=" $t('lan.vercode') " />
                <span class="regYes" v-if="isreg"><A class="f20">√</a>可以注册</span>
                <span if="isCorrect" class="f20" style="position:absolute; top:0; right:15px; color:#0f9ee6; line-height:45px;">{{codejudge}}</span>
            </p>
            <div class="fleft codeYz m2B">
                <p v-if="lang==1">
                    <span class="btnsub subBtn fleft show">{{$t('lan.regIn')}}</span>
                </p>
                <p v-else>
                    <span class="btnsub fleft show">{{$t('lan.regIn')}}</span>
                    <span v-if="lang==0" class="regCheck fleft show f20" @click="checkVer">{{ isVer ? verMail : verTel}}</span>
                </p>
                <div class="m10T" style="height:75px;" id="tpyzm" v-if="isToyzm" >
                    <form action="" method="POST" id="UserLoginFroms">
                        <div class="g-recaptcha" data-callback="robotVerified" data-sitekey="6Let7aUUAAAAADayc8HFOa0bKlEb3mQ5vr5U3ddT"></div>
                    </form>
                   <!-- <remote-script src="https://www.recaptcha.net/recaptcha/api.js"></remote-script>
                    <remote-script src="https://static.lanniuzai.com/js/jquery.form.js"></remote-script> -->
                </div>
            </div>
            <p class="js fleft">{{$t('lan.havAccount')}}<span class="m10L" @click="toLog">{{$t('lan.logIn')}}</span></p>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { Dialog } from 'vant';
Vue.use(Dialog);
export default {
    name: 'app',
    components: {
        
    },
    props:{

    },
    data(){
        return {
            lang: window.location.href.indexOf('bluejeanimages')>0 ? 1 : 0,
            isVer:false,
            verTel:'手机注册》',
            verMail:'邮箱注册》',
            vercode:'',
            regname:'',
            newpwd:'',
            oldpwd:'',
            ver:'',
            ispwdN:false,
            ispwdO:false,
            isname:false,
            isverName:false,
            verName:'',
            isToyzm:false,
            isreg:false,
            iscode:false,
            timer:0,
            codeName:'',
            times:'60',
            istime:false,
            username:this.$t('lan.reguser'),
            isCorrect:false,
            codejudge:'',
        }
    },
    created() {
        this.verName=this.isVer ?  this.$t('lan.mobtel') :  this.$t('lan.email') ;
        this.codeName=(this.lang==1) ? this.$t('lan.mailcode') : this.$t('lan.telcode');
    },
    mounted(){

    },
    destroyed(){
    
    },
    methods:{
        //关闭注册窗口
        closed(){
            this.$emit('closeED',true)
        },
        //注册
        toLog(){
            this.$emit('closeType',1)
        },
        //切换验证码
        getCode(){
            if(this.isVer){
                this.checkTel();
            }else{
                this.checkMail();
            }
        },
        //得焦点
        focusfns(type){
            if(type==1){
                this.isname=false;
                this.ispwdO=false;
                this.isverName=false;
                this.ispwdN=false;
            }else if(type==2){
                this.ispwdN=false;
                this.ispwdO=false;
                this.isverName=false;
            }else if(type==3){
                this.ispwdO=false;
                this.isverName=false;
            }else{
                this.isverName=false;
            }
        },
        //失焦点
        blurfns(type){
            if(type==1){
                if(this.regname==''){
                    this.isname=true;
                }else{
                    this.isname=false;
                    this.chekName();
                }
            }else if(type==2){
                if(this.newpwd==''){
                    this.ispwdN=true;
                }else{
                    this.ispwdN=false;
                }
            }else if(type==3){
                if(this.oldpwd==''){
                    this.ispwdO=true;
                }else{
                    this.ispwdO=false;
                }
            }else if(type==4){
                if(this.ver==''){
                    this.isverName=true;
                }else{
                    this.isverName=false;
                }
            }
        },
        //验证是否注册过
        async chekName(){
			let _this = this;
			let data = {
				userName : _this.regname
			}
			await _this.$api.checkRegname(data).then((res)=>{
                if( res.result==1){  
                    this.isname=false;
                }else if(res.result==0){
                    this.isname=true;
                    Dialog.alert({
                        title: '温馨提示',
                        message: res.resultMsg,
                    })
                    return;
                }
            }).catch((err)=>{
                
                console.log("请求失败") 
            })
        },
        //切换验证
        checkVer(){
            this.isVer=!this.isVer;
            this.verName=this.isVer ?  this.$t('lan.mobtel') :  this.$t('lan.email') ;
        },
        //先验证密码是否为空
        checknamepwd(){
            var pwd1=this.newpwd;
            var pwd=this.oldpwd;
            if(this.regname==''){
                this.isname=true;
                return;
            }
            if(this.pwd1=='' ){
                this.ispwdN=true;
                return;
            }
            if(pwd.val()==''){
                this.ispwdO=true;
                return;
            }
        },
        //验证密码是否一样
        checkPwd(){
            if(this.oldpwd != this.newpwd){
                this.ispwdO=true;
                Dialog.alert({
                    title: '温馨提示',
                    message: '两次密码不一致',
                })
                return;
            }
        },
        //验证手机
        async checkTel(){
			let _this = this;
            this.checknamepwd();
            var phone = this.ver;
            var pattern = /^1[0-9]{10}$/;
            if(phone == '') {
                this.isverName=true;
                return;
            }
            if(!pattern.test(phone)){
                this.isverName=true;
                this.verName='请输入正确的手机号码';
                return;
            }
			let data = {
				mobile: phone
			}
            await _this.$api.getCheckMobile(data).then((res)=>{
                var res = res.data; 
                if( res.result==1){  
					this.isreg=true;
					this.recapt();
                }else if(res.result==0){
					this.isverName=true;
					this.verName='该手机号已注册可直接使登录';
					return;
                }
            }).catch((err)=>{
                
                console.log("请求失败") 
            })
        },
        //验证邮箱
        async checkMail(){
            this.checknamepwd();
            var email=this.ver;
            //eileen.lee@sg.leoburnett.com
            var reg = /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_.-])+((\.[a-zA-Z0-9_-]{2,9}){1,2})$/

            if (email == '') {
                this.isverName=true;
                return;
            } else if (!reg.test(email.val())) {
                this.isverName=true;
                this.verName=this.$t('lan.gsName');
                return;
            }
            let data = {
                email: email,    
            };
            await _this.$api.getCheckEmail(data).then((res)=>{
                var res = res.data; 
                if( res.result==1){  
                    this.isreg=true;
                    this.mailVerified();
                }else if(res.result==0){
                    this.isverName=true;
                    this.verName=this.$t('lan.beMail');
                    return;
                }
            }).catch((err)=>{
                console.log("请求失败") 
            })
        },
        //发送邮件
        async mailVerified(id){
			let _this = this;
            let data = {
                authcodeType:"restPwd",
                email:this.ver     
            };
            await _this.$api.getMailcode(data).then((res)=>{
                var res = res.data; 
                if( res.result==1){  
                    this.isreg=true;
                }else if(res.result==0){
                    this.isverName=true;
                    this.verName=this.$t('lan.mailerror');
                    return;
                }
            }).catch((err)=>{
                console.log("请求失败") 
            })
            this.cleartime();
            this.times='600';
            settime(600,id);
        },
        cleartime(){
            this.istime=true;
            clearInterval(this.timer);
        },
        //人机验证码
        recapt(id){
            this.isToyzm=true;
        },
        //人机验证 后 返回接口
        async robotVerified(data){
			let _this = this;
            if(!data){
                return;
            }
            var recaptcha=data;
            var id='pwdNode';
            let dataJson = {
				smsType:"authcodeResetPwd",
				mobile:this.ver ,
				'g-recaptcha-response' : recaptcha     
            };
            await _this.$api.getSmscode(dataJson).then((res)=>{
            var res = res.data; 
            if( res.code==1){  
                this.isreg=true;
            }else if(res.code==0){
                this.isverName=true;
                this.verName=this.$t('lan.dailesend');
                return;
            }
            }).catch((err)=>{
                console.log("请求失败") 
            })
            //验证码有效时间2分钟，验证码有效时间内不能再次发送。
            // 单个ip地址一天10条短信验证码，单个手机号每天5条
            this.cleartime();
            this.times='600';
            settime(600,id);
        },
        settime(second){
            this.timer = setInterval(function(){
                second -= 1;
                if(second >0 ){
                    this.times= second;
                }else{
                    clearInterval(timer);
                    this.istime=false;
                }
            },1000);
        },
        //注册
        async regist(type){
			let _this = this;
            var phone=this.ver;
            var name=this.regname;
            var email=this.ver;
            var pwd1=newpwd;
            var pwd=oldpwd;
            var telcode=this.code;
            var regName=/^([\u4E00-\uFA29]|[\uE7C7-\uE7F3]|[a-zA-Z0-9.-_])*$/;
            if (!this.userCheck(name)) { 
                return; 
            }
            if(pwd1==''){
                this.ispwdN=true;
                return;
            }
            if(pwd.val()==''){
                this.ispwdO=true;
                return;
            }
            if(isVer){
                var passportType='sms';
                if(phone==''){
                    this.isverName=true;
                    return;
                }
                if(telcode==''){
                    this.iscode=true;
                    return;
                }
            }
            if(!isVer){
                var passportType='email';
                if (email == '') {
                    this.isverName=true;
                    return;
                }
                if(telcode.val()==''){
                    this.iscode=true;
                    return;
                }
            }
            var ajax_response = "";
            var data = {
                smsType:"authcodeResetPwd",
                mobile:this.ver ,
                'g-recaptcha-response' : recaptcha    
            };
            await _this.$api.getCodeuid(data).then((res)=>{
                var res = res.data; 
                ajax_response = data;
            }).catch((err)=>{
                console.log("请求失败") 
            })
            // $.ajax({
            //   url : $web+"authcode/uid",
            //   type : "get",
            //   cache : false,
            //   dataType : "text",
            //   async: false,
            //   success : function(data) {
            //   ajax_response = data;
            //   }
            // });
                this.axios.defaults.headers.uid = ajax_response;
                var data = {
                    mobile :phone,
                    authcode:telcode,
                    passportType:passportType,
                    userName:name,
                    password:pwd,
                    email:email,  
                    userGradeId : 1 
                };
                 await _this.$api.getRegister(data).then((res)=>{
                    var res = res.data; 
                    if(res.result==0){
                        Dialog.alert({
                            title: '温馨提示',
                            message: '注册失败',
                        })
                    }else if(res.result==1){
                        var obj={'userName':name,'pwd':pwd,'isLogin':'1'};
                        localStorage.setItem('record', JSON.stringify(obj) ); 
                        Dialog.alert({
                            title: '温馨提示',
                            message: this.$t('lan.sucreg'),
                        }).then(() => {
                            this.$emit('closeLog',true)
                        });
                    }
                }).catch((err)=>{
                    console.log("请求失败") 
                })
        },
        //验证名字
        userCheck(name) {
            var fullNumber = /^[0-9]+$/; //数字
            var len = betweenLength(name.val().replace(/[^\x00-\xff]/g, "**"), 2, 30);
            if (name == "") {
                this.isname=true;
                return false;
            }else if (!len) {
                this.isname=true;
                this.username=this.$t('lan.shortYhm');
                return false;
            }
            return true;
        },
        //短信验证码判断
        async checknote(){
            var code=this.vercode;
            let data = {
                mobile: this.ver,       
                smsAuthcode: code  
            };
            await _this.$api.checkSmscode(data).then((res)=>{
                var res = res.data; 
                if( res.code==1){  
                this.isCorrect=true;
                this.codejudge='√';
                }else if(res.code==0){
                this.isCorrect=true;
                this.codejudge=this.$t('lan.codeerror');
                return;
                }
            }).catch((err)=>{
                console.log("请求失败") 
            })
        },
        async checkmialVer(){
			let _this = this;
            var code=this.vercode;
            let data = {
                email: this.ver,       
                authcode: code    
            };
            await _this.$api.checkMailscode(data).then((res)=>{
                var res = res.data; 
                if( res.code==1){  
                this.isCorrect=true;
                this.codejudge='√';
                }else if(res.code==0){
                this.isCorrect=true;
                this.codejudge=this.$t('lan.codeerror');
                return;
                }
            }).catch((err)=>{
                console.log("请求失败") 
            })
        }

    }
}
</script>
<style lang="scss" scoped>
    .info{
      width:750px;
      margin:0 auto;
      background: #fff;
      height:100%;
      position: fixed;
      top:0;
      left: 0;
      z-index: 2000;
      color:#4d4d4d;
    }
    .logInfo{
      width:670px;
      height:1000px;
      position:absolute;
      top:50%;
      left:50%;
      margin:-540px 0 0 -335px;
      height:auto;
      overflow: auto;
      zoom: 1;
      font-size:26px;
      .logo{
        width:100%;
        height:100px;
        text-align: center;
        img{
          width:300px;
          height:90px;
        }
      }
      .tit{
        width:100%;
        line-height:170px;
        font-size:30px;
        text-align: center;
        height:170px;
        border-bottom:solid 2px #cbcbcb;
      }
      .putlist{
        width:100%;
        height:560px;
        li{
          width:100%;
          float: left;
          height:138px;
          border-bottom:solid 2px #cbcbcb;
          .inputcls{
            width:630px;
            height:78px;
            line-height:78px;
            padding:30px 20px;
          }

        }
      }
      .btnsub{
        width:500px;
        height:100px;
        line-height:100px;
        background:#00a8ff;
        color:#fff;
        text-align: center;
        float: left;
        letter-spacing: 8px;
        font-size:36px;
      }
      .btnsub:hover{
        background:#0197e4;
      }
      .subBtn{
        width:100%;
      }
      .regCheck{
        width:150px;
        text-align: center;
      }
      .js{
        font-size:22px;
        line-height:96px;
        text-align: center;
        width:100%;
        height:96px;
      }
      .codeYz{
        width:100%;
        height:100px;
        overflow: hidden;
        line-height:100px;
        .regYes{
          position: absolute;
          right:20px;
        }
      }
      .codePut{
        padding:10px 0;
        border-bottom:solid 2px #cbcbcb;
        margin-bottom:25px;
      }
      .putcode{
        width:308px;
        height:100px;
        padding:0 20px;
        font-size:36px;
        margin-bottom:1px;
      }
      .codeBtn{
        width:300px;
        height:100px;
        background:#ccc;
        text-align: center;
        color:#fff;
        font-size:30px;
        
      }
    }
    
</style>
